import { render, staticRenderFns } from "./surveyStartDialog.vue?vue&type=template&id=5e8400b0"
import script from "./surveyStartDialog.vue?vue&type=script&lang=js"
export * from "./surveyStartDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports